import { APIPath } from '@/cms/api/constants';
import { Entry, EntryVersion, PageResponse } from '@/cms/types';
import { apiCallStrapi, ApiCallStrapiProps } from '@/utils/fetch';

export interface FetchPageParams<T extends Entry> {
  apiPath: APIPath;
  slug?: string;
  documentId?: string;
  status?: EntryVersion;
  tags?: string[];
  /** Strapi populate depth. Default `deep` for the full page payload. */
  pLevel?: string;
  fetchOptions?: ApiCallStrapiProps['fetchOptions'];
  envBridgeOptions?: ApiCallStrapiProps['envBridgeOptions'];
}

/** Strapi page fetch via Next Data Cache (force-cache + next.tags). */
export async function performStrapiFetch<T extends Entry>({
  apiPath,
  slug,
  documentId,
  status,
  tags,
  pLevel = 'deep',
  fetchOptions,
  envBridgeOptions,
}: FetchPageParams<T>): Promise<PageResponse<T>> {
  const filters = {
    ...(slug && { slug: { $eq: slug } }),
    ...(documentId && { documentId: { $eq: documentId } }),
  };

  const response = await apiCallStrapi<PageResponse<T>>({
    path: apiPath,
    query: {
      pLevel,
      filters,
      pagination: {
        pageSize: 1,
      },
    },
    method: 'GET',
    status,
    next: {
      tags,
    },
    fetchOptions: {
      cache: 'force-cache',
      ...fetchOptions,
    },
    envBridgeOptions,
    throwOnError: true,
  });

  return response ?? { data: [] };
}
